import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Input, Button } from '@getpay93/ui';
import type { PublicInvite } from '@getpay93/api';
import { api } from '../lib/api';
import { useAuth } from '../auth/AuthContext';
import { homePathFor } from '../auth/session';

export function Unirse() {
  const { acceptInviteAndAuth, logout } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState('');
  const [invite, setInvite] = useState<PublicInvite | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function lookup() {
    setError(null);
    setInvite(null);
    try {
      setInvite(await api.invites.publicLookup(code.trim()));
    } catch {
      setError('Código no encontrado o expirado.');
    }
  }

  async function join() {
    setBusy(true);
    setError(null);
    try {
      const s = await acceptInviteAndAuth({ code: code.trim() });
      nav(homePathFor(s), { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo unir');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'grid', placeItems: 'center', padding: 24 }}>
      <Card style={{ width: '100%', maxWidth: 420 }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, color: 'var(--text-strong)', marginTop: 0 }}>Unirme a un negocio</h1>
        <p style={{ color: 'var(--text-muted)', marginTop: 0, fontSize: 14 }}>Ingresa el código que te compartieron.</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <Input placeholder="Código (8 caracteres)" value={code} onChange={(e) => setCode(e.currentTarget.value.toUpperCase())} containerStyle={{ flex: 1 }} />
          <Button variant="outline" onClick={lookup} disabled={code.trim().length < 4}>Buscar</Button>
        </div>
        {error ? <p style={{ color: 'var(--status-overdue)', fontSize: 13, fontWeight: 600 }}>{error}</p> : null}
        {invite ? (
          <div style={{ marginTop: 14 }}>
            <div style={{ fontWeight: 800, color: 'var(--text-strong)' }}>{invite.orgName}</div>
            {invite.planName ? <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>Plan {invite.planName}{invite.price != null ? ` · $${invite.price}` : ''}</div> : null}
            <Button fullWidth disabled={busy} onClick={join} style={{ marginTop: 12 }}>{busy ? 'Uniéndote…' : 'Unirme'}</Button>
          </div>
        ) : null}
        <p style={{ textAlign: 'center', marginTop: 18, fontSize: 13 }}>
          <button onClick={logout} style={{ background: 'none', border: 'none', color: 'var(--link)', cursor: 'pointer', fontFamily: 'var(--font-sans)' }}>Cerrar sesión</button>
        </p>
      </Card>
    </div>
  );
}
